import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var checkbox = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_orakds2',variantClassNames:{size:{xsmall:'fx_2d2fb1e5_orakds3',small:'fx_2d2fb1e5_orakds4','default':'fx_2d2fb1e5_orakds5'}},defaultVariants:{size:'default'},compoundVariants:[]});
var checkboxActiveBackground = 'var(--fx_2d2fb1e5_orakds1)';
var checkboxClickable = 'fx_2d2fb1e5_orakds6';
var checkboxFocusVisible = 'fx_2d2fb1e5_orakds7';

export { checkbox, checkboxActiveBackground, checkboxClickable, checkboxFocusVisible };
//# sourceMappingURL=checkbox.vanilla.mjs.map
